/**
 * Returns one of the 4 lead-avatar gradient classes for a given key.
 * Deterministic so the same lead always gets the same colour.
 * Usage: <div className={`avatar ${leadAvatarClass(lead.id || lead.name)}`}>{initials}</div>
 */
export const leadAvatarClass = (key) => {
  const str = String(key || '');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  const slot = (hash % 4) + 1;
  return `lead-avatar-${slot}`;
};

/** Returns the broker/lead initials given a name. "Sarah Connor" → "SC". */
export const initials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
